import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';
import { useAuth0 } from '@auth0/auth0-react';

const fetchHomeBlogPosts = async (authenticatedFetch) => {
  try {
    const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/wordpress/posts?limit=3`);
    if (!response.ok) return [];
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

export const useHomeBlogPosts = () => {
  const { authenticatedFetch } = useAuthenticatedApi();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  
  return useQuery({
    queryKey: ['homeBlogPosts'],
    queryFn: () => fetchHomeBlogPosts(authenticatedFetch),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 0,
    enabled: !authLoading && isAuthenticated && !!authenticatedFetch,
  });
};

